import { render, staticRenderFns } from "./consulta_campo_text.vue?vue&type=template&id=ff454364&scoped=true"
import script from "./consulta_campo_text.vue?vue&type=script&lang=js"
export * from "./consulta_campo_text.vue?vue&type=script&lang=js"
import style0 from "./consulta_campo_text.vue?vue&type=style&index=0&id=ff454364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff454364",
  null
  
)

export default component.exports